import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import ActionChatStyle from "./ActionChat.Style";
import { envs } from "../../../config";
import * as LINKS from "../../../config/links";

const chatPopUpProps = {
  height: 600,
  width: 500,
  status: "yes",
  fullscreen: "no",
  toolbar: "no",
  menubar: "no",
  location: "no",
};

const ActionChat = (props) => {
  const { chatId } = props;

  const RedirectToCap = () => {
    if (chatId !== "57336000000D2xX") {
      return `${envs.hostAtendimentoChat}/LiveAgentChatRouting?button_id=${chatId}`;
    }
    return LINKS.CnpNovaMarca;
  };

  const linkChat = useMemo(RedirectToCap, [chatId]);

  const chatButtonHandle = useCallback(
    (evt) => {
      if (linkChat !== LINKS.CnpNovaMarca) {
        evt.preventDefault();
        window.open(
          linkChat,
          null,
          Object.keys(chatPopUpProps)
            .map((key) => `${key}=${chatPopUpProps[key]}`)
            .join(", ")
        );
      }

      if (linkChat === LINKS.CnpNovaMarca) {
        window.open(LINKS.CnpNovaMarca, null);
      }
    },
    [linkChat]
  );

  return (
    <ActionChatStyle
      {...props}
      onClick={chatButtonHandle}
      href={linkChat}
      target="_blank"
    />
  );
};

ActionChat.propTypes = {
  chatId: PropTypes.string.isRequired,
};

export default ActionChat;
